import { Tooltip } from 'components/ui/tooltip';
import { t } from 'utils/getTranslations';

/** The mark of an AML-applicable practice area, inside its chip in the case's read view and in its form. */
export function AmlMark() {
    return (
        <Tooltip content={t('matters.aml-applicable-tooltip')}>
            <span className="text-warning-ink">· {t('matters.aml')}</span>
        </Tooltip>
    );
}
